export default [
    {
        path: '/payment-type-settings',
        name: 'payment-type-settings',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Configurações de Eventos',
            icon: 'mdi-cog',
            breadcrumbs: [
                { text: 'Lista de Configurações de Eventos', disabled: true }
            ]
        }
    }
]